import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectSettingLogo } from 'src/app/stores/settings';

import { ConnectionIndicatorComponent } from '../../shared/components/connection-indicator/connection-indicator.component';
import { LogoComponent } from '../../shared/components/logo/logo.component';

@Component({
  selector: 'frodo-page-shell',
  standalone: true,
  imports: [CommonModule, LogoComponent, ConnectionIndicatorComponent],
  templateUrl: './page-shell.component.html',
  styleUrls: ['./page-shell.component.scss'],
})
export class PageShellComponent {
  @Input() goBack?: () => void;
  @Input() showConnectionIndicator = false;

  readonly logoSrc$ = this.store.select(selectSettingLogo);

  constructor(private store: Store) {}
}
